module.exports = __webpack_public_path__ + "img/54.cb924370.jpg";